import { render, staticRenderFns } from "./DataContainer.vue?vue&type=template&id=93ef8c9c&scoped=true&"
import script from "./DataContainer.vue?vue&type=script&lang=js&"
export * from "./DataContainer.vue?vue&type=script&lang=js&"
import style0 from "./DataContainer.vue?vue&type=style&index=0&id=93ef8c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ef8c9c",
  null
  
)

export default component.exports